module.exports = __webpack_public_path__ + "img/franchising_why_2.be7431ba.svg";